import React from "react";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";
import * as _ from "lodash";
import { formatComma } from "../../utils/stringFormat";
import { URL_POST_BAKING } from "../../constance/urls";
import { DELETE } from "../../utils/HttpClient";
import { Toast } from "../../utils/Toast";
import ConfirmModal from "../../components/common/ConfirmModal";
import { List, Card, Button, Space } from "antd";
import Title from "antd/es/typography/Title";
import { SearchOutlined, DeleteFilled, EditFilled } from "@ant-design/icons";
import { BLUE_COLOR } from "../../constance/color";
import ColorButton from "../common/ColorButton";


export default function WasteWoodSizeAmountMapList(props) {
  const {
    style,
    readOnly,
    dataList,
    onEdit,
    fetchData,
  } = props;

  const { t } = useTranslation();
  const [deleteTarget, setDeleteTarget] = React.useState(null);
  const [loading, setLoading] = React.useState(false);

  const handleDelete = async () => {
    setLoading(true);
    try {
      await DELETE(`${URL_POST_BAKING.POST_BAKING_WASTE_WOOD_INPUT}${deleteTarget}/`);
      setDeleteTarget(null);
      fetchData();
    } catch (error) {
      Toast.error(`${t('delete')} ${t('error')} : ${error.errorMessages}`)
    } finally {
      setLoading(false);
    }
  }

  return (
    <div>
      <div style={{ margin: '4rem auto', marginTop: '24px', width: 'fit-content', ...style }}>
        {dataList.length ? (
          <List >
            {dataList.map(data => (
              <List.Item>
                <Card style={{ borderBlockStartColor: BLUE_COLOR, width: '100%' }}>
                  <Title level={5} style={{ display: 'flex', columnGap: '1rem', alignItems: 'center', justifyContent: 'space-between', margin: 0}}>
                    <span>
                      {_.get(data, 'wood_code', '-')} : {formatComma(_.get(data, 'amount', 0))} {t('units.wood')}
                    </span>
                    {!readOnly && (
                      <Space>
                        <ColorButton
                          loading={loading}
                          variant="outlined"
                          color='primary'
                          override={BLUE_COLOR}
                          size='small'
                          onClick={() => onEdit(_.get(data, 'id', null))}><EditFilled />{t('edit')}</ColorButton>
                        <Button
                          loading={loading}
                          danger
                          size='small' onClick={() => setDeleteTarget(_.get(data, 'id', null))} ><DeleteFilled /></Button>
                      </Space>
                    )}
                  </Title>
                </Card>
              </List.Item>
            ))}
          </List>
        ) : (
          <div>
            <Title level={3} textAlign='center' disabled><SearchOutlined /> {t('empty')}</Title>
          </div>
        )}
      </div>
      <ConfirmModal
        open={deleteTarget != null}
        onClose={() => setDeleteTarget(null)}
        title={`${t('confirms.delete_title')}`}
        content={`${t('confirms.delete_content')}`}
        onConfirm={handleDelete} />
    </div>
  )
}

WasteWoodSizeAmountMapList.propTypes = {
  style: PropTypes.bool,
  readOnly: PropTypes.bool,
  fullDetail: PropTypes.bool,
  dataList: PropTypes.array,
  onEdit: PropTypes.func,
  fetchData: PropTypes.func,
}

WasteWoodSizeAmountMapList.defaultProps = {
  style: {},
  readOnly: false,
  fullDetail: false,
  dataList: [],
  onEdit: () => null,
  fetchData: () => null,
}